// extracted by mini-css-extract-plugin
module.exports = {"SecInner":"SectionInner_SecInner__nx19L","SecInner__wrapper":"SectionInner_SecInner__wrapper__iXyb0"};